<template>
  <div class="category-row">
    <span class='category-group category-group-sides'>
      <CategoryAchievementRing
          v-for="(cat) in categoriesLeft"
          :key="cat.category.name"
          :film_ids="film_ids(cat)"
          :category="cat.category"
          :ceremony="ceremony"
          :size="achievementSize(cat)"
          :disabled="disabled"
      >
      </CategoryAchievementRing>
    </span>

    <span class='category-group category-group-center'>
      <div>
        <CategoryAchievementRing
            v-for="(cat) in categoriesCenterTop"
            :key="cat.category.name"
            :film_ids="film_ids(cat)"
            :category="cat.category"
            :ceremony="ceremony"
            :size="achievementSize(cat)"
            :disabled="disabled"
        >
        </CategoryAchievementRing>
      </div>
      <div>
        <CategoryAchievementRing
            v-for="(cat) in categoriesCenterBottom"
            :key="cat.category.name"
            :film_ids="film_ids(cat)"
            :category="cat.category"
            :ceremony="ceremony"
            :size="achievementSize(cat)"
            :disabled="disabled"
        >
        </CategoryAchievementRing>
      </div>
    </span>

    <span class='category-group category-group-sides'>
      <CategoryAchievementRing
          v-for="(cat) in categoriesRight"
          :key="cat.category.name"
          :film_ids="film_ids(cat)"
          :category="cat.category"
          :ceremony="ceremony"
          :size="achievementSize(cat)"
          :disabled="disabled"
      >
      </CategoryAchievementRing>
    </span>

  </div>
</template>


<script>
import CategoryAchievementRing from "@/components/achievements/CategoryAchievementRing.vue";

export default {
  name: "CeremonyCardTopRow",
  /* eslint-disable vue/no-unused-components */
  components: {CategoryAchievementRing},
  props: ['ceremony', 'categories', 'disabled'],
  data() {
    return {
      categoriesLeft: [],
      categoriesRight: [],
      categoriesCenterTop: [],
      categoriesCenterBottom: [],
    }
  },
  created() {

    this.categoriesLeft = this.categories.filter(cat => {
      return cat.category.normalized_name.toUpperCase().includes('ACTOR');
    });
    this.categoriesRight = this.categories.filter(cat => {
      return cat.category.normalized_name.toUpperCase().includes('ACTRESS');
    });
    this.categoriesCenterTop = this.categories.filter(cat => {
      return cat.category.normalized_name.toUpperCase().includes('BEST PICTURE');
    });
    this.categoriesCenterBottom = this.categories.filter(cat => {
      return cat.category.normalized_name.toUpperCase().includes('DIRECTING');
    });


  },
  methods: {
    film_ids(cat) {
      return cat.films
          .filter(film_obj => !film_obj.unofficial_nom)
          .map(film_obj => film_obj.film_id);
    },
    isCenterCategory(_cat) {
      return (
          _cat.category.normalized_name.toUpperCase() === 'BEST PICTURE' ||
          _cat.category.normalized_name.toUpperCase() === 'DIRECTING'
      );
    },
    achievementSize(_cat) {
      return (
          _cat.category.normalized_name.toUpperCase().includes('BEST PICTURE')? '75px' : '50px'
      );
    }
  }
}
</script>


<style scoped>
.category-row {
  /*
  border: solid;
  border-color: lightgreen;
  border-width: 0.1px;
   */

  text-align: center;

  position: relative;
  display: block;

}

.category-group {
  position: relative;
  display: inline-block;
  vertical-align: bottom;

  &.category-group-sides {
    bottom: 25px;
  }

  &.category-group-center {
  }
}



</style>